module.exports = __webpack_public_path__ + "static/media/lock.a3d7f9f1.svg";